import React, { useEffect, useState } from 'react';
import PageLayout from 'components/layouts/PageLayout';
import NewButton from 'components/input/NewButton';
import ServiceHelper from 'stores/ServiceHelper';
import { AdminTagDto } from 'services/data-contracts';
import { useStoreWrapper } from 'stores/StoreHelper';

import { InnerSection } from 'components/layouts/CommonForm';
import { InnerGroup } from 'components/layouts/CommonForm';
import { Row } from 'saladsoft-primitive';
import Text from 'components/commons/Text';
import TagMasterItem from 'components/pages/listings/TagMasterItem';
import TagForm from 'components/pages/tags/TagForm';
import { TagModel } from 'types/CommonTypes';

const TagSettingPage = () => {
  const { uiStore } = useStoreWrapper();

  const [tags, setTags] = useState<AdminTagDto[]>([]);

  const handleClickTag = (tag?: AdminTagDto) => {
    uiStore?.modal.show({
      title: tag?.id ? '태그 수정' : '태그 추가',
      style: { width: 800, maxHeight: '80%' },
      children: (
        <div style={{ padding: 20 }}>
          <TagForm
            tag={tag}
            onSave={(tag?: TagModel) => {
              fetchTags();
            }}
          />
        </div>
      ),
    });
  };

  const fetchTags = () => {
    ServiceHelper?.adminTagService?.getTags1({ size: 1000 }).then((res) => {
      setTags(res.data);
    });
  };

  useEffect(() => {
    fetchTags();
  }, []);

  return (
    <PageLayout
      title="시스템태그 설정"
      actionButton={
        <NewButton
          onClick={() => {
            handleClickTag();
          }}
        >
          태그 추가
        </NewButton>
      }
    >
      <InnerSection style={{ minHeight: 'unset' }}>
        <InnerGroup>
          <div>
            <Text type="H3">태그 목록</Text>
            <Text type="H4" buttonRole="DESCRIPTION" style={{ margin: '10px 0' }}>
              시설의 태그관리를 할 수 있습니다.
              <br />
            </Text>
          </div>

          <Row gap={10} justifyContent="flex-start" flexWrap="wrap" marginTop={0}>
            {tags.map((tag) => (
              <TagMasterItem
                key={tag.id}
                tag={tag}
                onClick={() => {
                  handleClickTag(tag);
                }}
              />
            ))}
          </Row>
        </InnerGroup>
      </InnerSection>
    </PageLayout>
  );
};

export default TagSettingPage;
